{
  "version": "1.2.6",
  "objects": {
    "7430095584134578153": {
      "type": "frame",
      "id": "7430095584134578153",
      "z": 7343,
      "textContent": "",
      "left": -65.58922487967038,
      "top": 2458.0880763923847,
      "width": 400,
      "height": 500,
      "scaleX": 1.5142588638217511,
      "scaleY": 0.9698609724543658,
      "fill": "#FFFFFF",
      "opacity": 1,
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a2",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "children",
      "layoutGap": 10,
      "layoutPadding": 10,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "top"
    },
    "7430095584127907755": {
      "type": "frame",
      "id": "7430095584127907755",
      "z": 114,
      "textContent": "<p>Select date range</p>",
      "left": -55.58922487967038,
      "top": 2468.0880763923847,
      "width": 400,
      "height": 500,
      "scaleX": 1.4642588638217513,
      "scaleY": 0.16,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7430095584134578153",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": null,
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": "auto",
      "layoutPadding": 20,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7430095584138192908": {
      "type": "shape",
      "id": "7430095584138192908",
      "z": 115,
      "shapeName": "icon",
      "textContent": "",
      "left": 224.6849622036198,
      "top": 2496.499407042602,
      "width": 100,
      "height": 114.28571428571429,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.2115517136212015,
      "scaleY": 0.2115517136212015,
      "stroke": null,
      "strokeWidth": 2,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": "#333333",
      "angle": 0,
      "container": "7430095584127907755",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a1",
      "maskType": "none",
      "iconName": "fas/minus",
      "locked": false
    },
    "7430095584131368820": {
      "type": "wireframe",
      "id": "7430095584131368820",
      "z": 116,
      "top": 2488.5880763923847,
      "left": 266.1143206490301,
      "width": 240,
      "height": 40,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7430095584127907755",
      "layoutPosition": "a3",
      "wireframeName": "datePicker",
      "fill": "#CACACA",
      "itemsData": {
        "7427497414596302796": {
          "id": "7427497414596302796",
          "value": "Item",
          "item_position": 2000000
        },
        "7427497414597361860": {
          "id": "7427497414597361860",
          "value": "Item",
          "item_position": 1000000
        },
        "7427497414602783165": {
          "id": "7427497414602783165",
          "value": "Item",
          "item_position": 0
        }
      },
      "textColor": "#333333",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "End date", "position": "noLabel" },
      "placeholder": {
        "state": "placeholder",
        "value": "End date",
        "iconRight": { "prefix": "fas", "iconName": "calendar-days" }
      }
    },
    "7430095584135368442": {
      "type": "wireframe",
      "id": "7430095584135368442",
      "z": 117,
      "top": 2488.5880763923847,
      "left": -35.58922487967038,
      "width": 240,
      "height": 40,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7430095584127907755",
      "layoutPosition": "a0V",
      "wireframeName": "datePicker",
      "fill": "#CACACA",
      "itemsData": {
        "7427497414596302796": {
          "id": "7427497414596302796",
          "value": "Item",
          "item_position": 2000000
        },
        "7427497414597361860": {
          "id": "7427497414597361860",
          "value": "Item",
          "item_position": 1000000
        },
        "7427497414602783165": {
          "id": "7427497414602783165",
          "value": "Item",
          "item_position": 0
        }
      },
      "textColor": "#333333",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Start date", "position": "noLabel" },
      "placeholder": {
        "state": "placeholder",
        "value": "Start date",
        "iconRight": { "prefix": "fas", "iconName": "calendar-days" }
      }
    },
    "7430095584129651617": {
      "type": "frame",
      "id": "7430095584129651617",
      "z": 6899,
      "textContent": "Frame 107",
      "left": -55.58922487967038,
      "top": 2558.0880763923847,
      "width": 400,
      "height": 500,
      "scaleX": 1.4642588638217513,
      "scaleY": 0.749860972454366,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7430095584134578153",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a1",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "user",
      "layoutGap": "auto",
      "layoutPadding": 20,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7430095584138920913": {
      "type": "frame",
      "id": "7430095584138920913",
      "z": 6900,
      "textContent": "Frame 133",
      "left": -35.58922487967038,
      "top": 2578.0880763923847,
      "width": 400,
      "height": 500,
      "scaleX": 1.3642588638217512,
      "scaleY": 0.08457142857142858,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7430095584129651617",
      "notInNavigation": false,
      "componentName": "",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "user",
      "layoutGap": 20,
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7430095584132328203": {
      "type": "shape",
      "id": "7430095584132328203",
      "z": 6901,
      "shapeName": "icon",
      "textContent": "",
      "left": 169.31662499565763,
      "top": 2588.5635596320217,
      "width": 100,
      "height": 200,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.10667373903219943,
      "scaleY": 0.10667373903219943,
      "stroke": null,
      "strokeWidth": 2,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": "#333333",
      "angle": 0,
      "container": "7430095584138920913",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "Zz",
      "maskType": "none",
      "iconName": "fas/angle-left",
      "locked": false
    },
    "7430095584132036276": {
      "type": "shape",
      "id": "7430095584132036276",
      "z": 6902,
      "shapeName": "icon",
      "textContent": "",
      "left": 289.9839988988776,
      "top": 2588.0064616604172,
      "width": 100,
      "height": 200,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.1122447187482453,
      "scaleY": 0.1122447187482453,
      "stroke": null,
      "strokeWidth": 2,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": "#333333",
      "angle": 0,
      "container": "7430095584138920913",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a1",
      "maskType": "none",
      "iconName": "fas/angle-right",
      "locked": false
    },
    "7430095584142093042": {
      "type": "shape",
      "id": "7430095584142093042",
      "z": 6903,
      "shapeName": "text",
      "textContent": "<p>Month</p>",
      "left": 199.9839988988776,
      "top": 2578.230933535242,
      "width": 49,
      "height": 29.4,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1.4285714285714286,
      "scaleY": 1.4285714285714286,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 20,
      "angle": 0,
      "container": "7430095584138920913",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a0",
      "maskType": "none",
      "locked": false
    },
    "7430095642001730553": {
      "type": "frame",
      "id": "7430095642001730553",
      "z": 6904,
      "textContent": "Frame 126",
      "left": -35.58922487967038,
      "top": 2625.373790678099,
      "width": 400,
      "height": 500,
      "scaleX": 1.3642588638217512,
      "scaleY": 0.08754825731382289,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7430095584129651617",
      "notInNavigation": false,
      "componentName": "",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": "auto",
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7430095641994472889": {
      "type": "shape",
      "id": "7430095641994472889",
      "z": 6905,
      "shapeName": "text",
      "textContent": "<p><span style=\"color:#BDBDBD\">SU</span></p>",
      "left": -35.58922487967038,
      "top": 2632.7608550065547,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095642001730553",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a0",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095642004677073": {
      "type": "shape",
      "id": "7430095642004677073",
      "z": 6906,
      "shapeName": "text",
      "textContent": "<p><span style=\"color:#BDBDBD\">MO</span></p>",
      "left": 49.09698341483803,
      "top": 2632.7608550065547,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095642001730553",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a1",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095642002903962": {
      "type": "shape",
      "id": "7430095642002903962",
      "z": 6907,
      "shapeName": "text",
      "textContent": "<p><span style=\"color:#BDBDBD\">TU</span></p>",
      "left": 133.78319170934645,
      "top": 2632.7608550065547,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095642001730553",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a2",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095641992496573": {
      "type": "shape",
      "id": "7430095641992496573",
      "z": 6908,
      "shapeName": "text",
      "textContent": "<p><span style=\"color:#BDBDBD\">WE</span></p>",
      "left": 218.46940000385487,
      "top": 2632.7608550065547,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095642001730553",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a3",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095642003394040": {
      "type": "shape",
      "id": "7430095642003394040",
      "z": 6909,
      "shapeName": "text",
      "textContent": "<p><span style=\"color:#BDBDBD\">TH</span></p>",
      "left": 303.15560829836323,
      "top": 2632.7608550065547,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095642001730553",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a4",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095641997925656": {
      "type": "shape",
      "id": "7430095641997925656",
      "z": 6910,
      "shapeName": "text",
      "textContent": "<p><span style=\"color:#BDBDBD\">FR</span></p>",
      "left": 387.8418165928716,
      "top": 2632.7608550065547,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095642001730553",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a5",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095641997203697": {
      "type": "shape",
      "id": "7430095641997203697",
      "z": 6911,
      "shapeName": "text",
      "textContent": "<p><span style=\"color:#BDBDBD\">SA</span></p>",
      "left": 472.52802488738,
      "top": 2632.7608550065547,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095642001730553",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a6",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095584125615060": {
      "type": "frame",
      "id": "7430095584125615060",
      "z": 6919,
      "textContent": "Frame 126",
      "left": -35.58922487967038,
      "top": 2674.1479193350106,
      "width": 400,
      "height": 500,
      "scaleX": 1.3642588638217512,
      "scaleY": 0.08754825731382289,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7430095584129651617",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a6",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "user",
      "layoutGap": "auto",
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7430095584126459901": {
      "type": "shape",
      "id": "7430095584126459901",
      "z": 6920,
      "shapeName": "text",
      "textContent": "<p><span style=\"color:#000000\">1</span></p>",
      "left": 133.78319170934645,
      "top": 2681.5349836634664,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095584125615060",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a2",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095584129092505": {
      "type": "shape",
      "id": "7430095584129092505",
      "z": 6921,
      "shapeName": "text",
      "textContent": "<p><span style=\"color:#BDBDBD\">29</span></p>",
      "left": -35.58922487967038,
      "top": 2681.5349836634664,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 0.5,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095584125615060",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a0",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095584126516481": {
      "type": "shape",
      "id": "7430095584126516481",
      "z": 6922,
      "shapeName": "text",
      "textContent": "<p><span style=\"color:#BDBDBD\">30</span></p>",
      "left": 49.09698341483803,
      "top": 2681.5349836634664,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 0.5,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095584125615060",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a1",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095584131462646": {
      "type": "shape",
      "id": "7430095584131462646",
      "z": 6923,
      "shapeName": "text",
      "textContent": "<p><span style=\"color:#000000\">2</span></p>",
      "left": 218.46940000385487,
      "top": 2681.5349836634664,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095584125615060",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a3",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095584139540833": {
      "type": "shape",
      "id": "7430095584139540833",
      "z": 6924,
      "shapeName": "text",
      "textContent": "<p><span style=\"color:#000000\">5</span></p>",
      "left": 472.52802488738,
      "top": 2681.5349836634664,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095584125615060",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a6",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095584132554518": {
      "type": "shape",
      "id": "7430095584132554518",
      "z": 6925,
      "shapeName": "text",
      "textContent": "<p><span style=\"color:#000000\">3</span></p>",
      "left": 303.15560829836323,
      "top": 2681.5349836634664,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095584125615060",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a4",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095584126636406": {
      "type": "shape",
      "id": "7430095584126636406",
      "z": 6926,
      "shapeName": "text",
      "textContent": "<p><span style=\"color:#000000\">4</span></p>",
      "left": 387.8418165928716,
      "top": 2681.5349836634664,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095584125615060",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a5",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095685097408637": {
      "type": "frame",
      "id": "7430095685097408637",
      "z": 6927,
      "textContent": "Frame 126",
      "left": -35.58922487967038,
      "top": 2722.922047991922,
      "width": 400,
      "height": 500,
      "scaleX": 1.3642588638217512,
      "scaleY": 0.08754825731382289,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7430095584129651617",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a6V",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": "auto",
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7430095685093999483": {
      "type": "shape",
      "id": "7430095685093999483",
      "z": 6928,
      "shapeName": "text",
      "textContent": "<p>7</p>",
      "left": 49.09698341483803,
      "top": 2730.309112320378,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095685097408637",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a1",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095685096136044": {
      "type": "shape",
      "id": "7430095685096136044",
      "z": 6929,
      "shapeName": "text",
      "textContent": "<p>6</p>",
      "left": -35.58922487967038,
      "top": 2730.309112320378,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095685097408637",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a0",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095685102120404": {
      "type": "shape",
      "id": "7430095685102120404",
      "z": 6930,
      "shapeName": "text",
      "textContent": "<p>9</p>",
      "left": 218.46940000385487,
      "top": 2730.309112320378,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095685097408637",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a3",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095685093196852": {
      "type": "shape",
      "id": "7430095685093196852",
      "z": 6931,
      "shapeName": "text",
      "textContent": "<p>10</p>",
      "left": 303.15560829836323,
      "top": 2730.309112320378,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095685097408637",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a4",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095685095051798": {
      "type": "shape",
      "id": "7430095685095051798",
      "z": 6932,
      "shapeName": "text",
      "textContent": "<p>8</p>",
      "left": 133.78319170934645,
      "top": 2730.309112320378,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095685097408637",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a2",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095685109873140": {
      "type": "shape",
      "id": "7430095685109873140",
      "z": 6933,
      "shapeName": "text",
      "textContent": "<p>11</p>",
      "left": 387.8418165928716,
      "top": 2730.309112320378,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095685097408637",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a5",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095685098000532": {
      "type": "shape",
      "id": "7430095685098000532",
      "z": 6934,
      "shapeName": "text",
      "textContent": "<p>12</p>",
      "left": 472.52802488738,
      "top": 2730.309112320378,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095685097408637",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a6",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095584153046655": {
      "type": "frame",
      "id": "7430095584153046655",
      "z": 6942,
      "textContent": "Frame 126",
      "left": -35.58922487967038,
      "top": 2771.696176648834,
      "width": 400,
      "height": 500,
      "scaleX": 1.3642588638217512,
      "scaleY": 0.08754825731382289,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7430095584129651617",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a8",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "user",
      "layoutGap": "auto",
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7430095584157668325": {
      "type": "shape",
      "id": "7430095584157668325",
      "z": 6943,
      "shapeName": "text",
      "textContent": "<p>13</p>",
      "left": -35.58922487967038,
      "top": 2779.0832409772897,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095584153046655",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a0",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095584155996747": {
      "type": "shape",
      "id": "7430095584155996747",
      "z": 6944,
      "shapeName": "text",
      "textContent": "<p>14</p>",
      "left": 49.09698341483803,
      "top": 2779.0832409772897,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095584153046655",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a1",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095584151396561": {
      "type": "shape",
      "id": "7430095584151396561",
      "z": 6945,
      "shapeName": "text",
      "textContent": "<p>15</p>",
      "left": 133.78319170934645,
      "top": 2779.0832409772897,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095584153046655",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a2",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095584151868774": {
      "type": "shape",
      "id": "7430095584151868774",
      "z": 6946,
      "shapeName": "text",
      "textContent": "<p>16</p>",
      "left": 218.46940000385487,
      "top": 2779.0832409772897,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095584153046655",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a3",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095584142666559": {
      "type": "shape",
      "id": "7430095584142666559",
      "z": 6947,
      "shapeName": "text",
      "textContent": "<p>17</p>",
      "left": 303.15560829836323,
      "top": 2779.0832409772897,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095584153046655",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a4",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095584153544841": {
      "type": "shape",
      "id": "7430095584153544841",
      "z": 6948,
      "shapeName": "text",
      "textContent": "<p>18</p>",
      "left": 387.8418165928716,
      "top": 2779.0832409772897,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095584153046655",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a5",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095584154395340": {
      "type": "shape",
      "id": "7430095584154395340",
      "z": 6949,
      "shapeName": "text",
      "textContent": "<p>19</p>",
      "left": 472.52802488738,
      "top": 2779.0832409772897,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095584153046655",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a6",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095584147996413": {
      "type": "frame",
      "id": "7430095584147996413",
      "z": 6950,
      "textContent": "Frame 126",
      "left": -35.58922487967038,
      "top": 2820.4703053057456,
      "width": 400,
      "height": 500,
      "scaleX": 1.3642588638217512,
      "scaleY": 0.08754825731382289,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7430095584129651617",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a9",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "user",
      "layoutGap": "auto",
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7430095584155813494": {
      "type": "shape",
      "id": "7430095584155813494",
      "z": 6951,
      "shapeName": "text",
      "textContent": "<p>24</p>",
      "left": 303.15560829836323,
      "top": 2827.8573696342014,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095584147996413",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a4",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095584156912244": {
      "type": "shape",
      "id": "7430095584156912244",
      "z": 6952,
      "shapeName": "text",
      "textContent": "<p>20</p>",
      "left": -35.58922487967038,
      "top": 2827.8573696342014,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095584147996413",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a0",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095584142721451": {
      "type": "shape",
      "id": "7430095584142721451",
      "z": 6953,
      "shapeName": "text",
      "textContent": "<p>21</p>",
      "left": 49.09698341483803,
      "top": 2827.8573696342014,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095584147996413",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a1",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095584142579994": {
      "type": "shape",
      "id": "7430095584142579994",
      "z": 6954,
      "shapeName": "text",
      "textContent": "<p>23</p>",
      "left": 218.46940000385487,
      "top": 2827.8573696342014,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095584147996413",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a3",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095584157423818": {
      "type": "shape",
      "id": "7430095584157423818",
      "z": 6955,
      "shapeName": "text",
      "textContent": "<p>25</p>",
      "left": 387.8418165928716,
      "top": 2827.8573696342014,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095584147996413",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a5",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095584148921279": {
      "type": "shape",
      "id": "7430095584148921279",
      "z": 6956,
      "shapeName": "text",
      "textContent": "<p>22</p>",
      "left": 133.78319170934645,
      "top": 2827.8573696342014,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095584147996413",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a2",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095584146333983": {
      "type": "shape",
      "id": "7430095584146333983",
      "z": 6957,
      "shapeName": "text",
      "textContent": "<p>26</p>",
      "left": 472.52802488738,
      "top": 2827.8573696342014,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095584147996413",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a6",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095735538876124": {
      "type": "frame",
      "id": "7430095735538876124",
      "z": 6958,
      "textContent": "Frame 126",
      "left": -35.58922487967038,
      "top": 2869.2444339626572,
      "width": 400,
      "height": 500,
      "scaleX": 1.3642588638217512,
      "scaleY": 0.08754825731382289,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7430095584129651617",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a9V",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": "auto",
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7430095735531002064": {
      "type": "shape",
      "id": "7430095735531002064",
      "z": 6959,
      "shapeName": "text",
      "textContent": "<p>27</p>",
      "left": -35.58922487967038,
      "top": 2876.631498291113,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095735538876124",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a0",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095735527548275": {
      "type": "shape",
      "id": "7430095735527548275",
      "z": 6960,
      "shapeName": "text",
      "textContent": "<p>31</p>",
      "left": 303.15560829836323,
      "top": 2876.631498291113,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095735538876124",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a4",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095735531665251": {
      "type": "shape",
      "id": "7430095735531665251",
      "z": 6961,
      "shapeName": "text",
      "textContent": "<p><span style=\"color:#BDBDBD\">1</span></p>",
      "left": 387.8418165928716,
      "top": 2876.631498291113,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 0.5,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095735538876124",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a5",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095735528495729": {
      "type": "shape",
      "id": "7430095735528495729",
      "z": 6962,
      "shapeName": "text",
      "textContent": "<p>30</p>",
      "left": 218.46940000385487,
      "top": 2876.631498291113,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095735538876124",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a3",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095735536562578": {
      "type": "shape",
      "id": "7430095735536562578",
      "z": 6963,
      "shapeName": "text",
      "textContent": "<p><span style=\"color:#BDBDBD\">2</span></p>",
      "left": 472.52802488738,
      "top": 2876.631498291113,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 0.5,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095735538876124",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a6",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095735526175235": {
      "type": "shape",
      "id": "7430095735526175235",
      "z": 6964,
      "shapeName": "text",
      "textContent": "<p>29</p>",
      "left": 133.78319170934645,
      "top": 2876.631498291113,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095735538876124",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a2",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7430095735530812616": {
      "type": "shape",
      "id": "7430095735530812616",
      "z": 6965,
      "shapeName": "text",
      "textContent": "<p>28</p>",
      "left": 49.09698341483803,
      "top": 2876.631498291113,
      "width": 37.586295761650035,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 1,
      "textAlign": "center",
      "fontSize": 14,
      "angle": 0,
      "container": "7430095735538876124",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a1",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    }
  }
}
